import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
} from '@angular/core';
import { NgIcon } from '@ng-icons/core';
import {
    resolveColorContext,
    type ContextFamily,
    type ContextTone,
} from '@quipex/shared/utils';
import { QpxIcon } from '../../directives';

export type QpxHeroIconContext = ContextFamily;

@Component({
    selector: 'qpx-hero-icon',
    imports: [NgIcon, QpxIcon],
    template: `
        <!-- eslint-disable-next-line agentic/no-single-template-wrapper -->
        <ng-icon qpx [context]="context()" [name]="name()" [size]="size()" />
    `,
    styleUrl: './hero-icon.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'qpx-hero-icon inline-flex items-center justify-center rounded-sm px-2 py-1',
        '[style.--qpx-hero-icon-bg]': 'containerBgVar()',
        '[class.active]': 'active()',
    },
})
export class QpxHeroIcon {
    //#region Inputs
    public readonly name = input.required<string>();
    public readonly context = input.required<QpxHeroIconContext>();
    public readonly tone = input<ContextTone>('muted');
    public readonly active = input<boolean>(false);
    public readonly size = input<'lg' | 'md' | 'sm' | 'xs'>('md');
    //#endregion

    //#region State
    protected readonly containerBgVar = computed(
        () =>
            `var(${resolveColorContext(this.context(), this.tone()).surface.variable})`
    );
    //#endregion
}
